// LivestreamOverlayCta.js
'use strict';
import { connect } from 'react-redux';

import {
  FEATURE_LIVESTREAM_SNAPSHOT,
  LIVESTREAM_PAY_DURATION_SECONDS,
} from '../RemoteConfigKeys.js';

import LivestreamOverlayCta from '../component/LivestreamOverlayCta.jsx';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData, {
  getIsMeExclusivePrivateBuyer,
} from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUserData from '../selector/getUserData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getPublicUrlHostname from '../selector/getPublicUrlHostname.js';
import { getLiveStreamExclusivePrivatePrice } from '../selector/getLiveStreamPrice.js';
import {
  getHasStreamToken,
  getLivestreamMode,
} from '../selector/getLivestreamComputedData.js';
import getMeBalance from '../selector/getMeBalance.js';
import addvalue from '../action/addvalue.js';
import unlockPrivateStream from '../action/unlockPrivateStream.js';
import fetchStreamsToken from '../action/fetchStreamsToken.js';

import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const username = getUserData(state, streamId, 'username');
  const displayName = getUserData(state, streamId, 'displayName');
  const balance = getMeBalance(state);
  const priceDurationMinutes =
    getRemoteConfigData(state, LIVESTREAM_PAY_DURATION_SECONDS) / 60;
  const publicUrlHostname = getPublicUrlHostname(state);
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const hasStreamToken = getHasStreamToken(state, streamId);

  return {
    meId: getMeData(state, 'id'),
    username,
    displayName,
    balance,
    mode: getLivestreamMode(state, streamId),
    exclusivePrice: getLiveStreamExclusivePrivatePrice(state, streamId),
    priceDurationMinutes,
    streamTitle: getLiveStreamData(state, [streamId], 'title'),
    categories: getLiveStreamData(state, [streamId], 'categories'),
    exclusivePrivateStatus,
    sessionId,
    isLiveStreamSnapshotEnabled: getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_SNAPSHOT
    ),
    publicUrlHostname,
    isExclusivePrivatePerforming:
      exclusivePrivateStatus === ExclusivePrivateStatus.PERFORMING,
    isExclusivePrivatePreparing:
      exclusivePrivateStatus === ExclusivePrivateStatus.PREPARING,
    isMeExclusivePrivateBuyer: getIsMeExclusivePrivateBuyer(state, streamId),
    hasStreamToken,
    isFetchingStreamToken: getNetworkingData(
      state,
      ['fetch', 'streamToken', sessionId],
      'isFetching'
    ),
    deviceWidth: getOperationData(state, ['device'], 'width'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addvalue: () => dispatch(addvalue({ via: 'unlock-livestream' })),
    unlockPrivateStream: data => dispatch(unlockPrivateStream(data)),
    fetchStreamsToken: data => dispatch(fetchStreamsToken(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamOverlayCta);
